module.exports = __webpack_public_path__ + "img/month.482ff372.svg";